import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("algo_token")) {
      setUser(false);
      return;
    }
    api
      .get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => setUser(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("algo_token", data.access_token);
    setUser(data.user);
  };

  const updateUser = (patch) => setUser((u) => (u ? { ...u, ...patch } : u));

  const requestAccess = (email) => api.post("/auth/access-request", { email });

  // Asks for a one-time sign-in code. Resolves to "sent" or "waiting".
  const requestCode = async (email) => {
    const { data } = await api.post("/auth/request-code", { email });
    return data.status;
  };

  const verifyCode = async (email, code) => {
    const { data } = await api.post("/auth/verify-code", { email, code });
    localStorage.setItem("algo_token", data.access_token);
    setUser(data.user);
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      // session already gone; clear locally anyway
    }
    localStorage.removeItem("algo_token");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, updateUser, requestAccess, requestCode, verifyCode }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
